import { BaseUniDriver, UniDriver } from '@wix/wix-ui-test-utils/unidriver';
import {
  baseUniDriverFactory,
  findByHook,
} from '../utils/test-utils/unidriver';
import { dataHooks } from './ListItemSection.constants';

export const listItemSectionDriverFactory = (base: UniDriver) => {
  return {
    ...baseUniDriverFactory(base),

    /** Get title Text */
    getTitle: (): Promise<string> => findByHook(base, dataHooks.TITLE).text(),

    /** Gets suffix */
    getSuffix: (): BaseUniDriver => {
      const value: unknown = findByHook(base, dataHooks.SUFFIX);
      return value as BaseUniDriver;
    },
  };
};

export type ListItemSectionUniDriver = ReturnType<
  typeof listItemSectionDriverFactory
>;
